import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../index.css";

const oneSystem = "https://onesystem.asherjewels.com.ph/";

function isVideoUrl(url) {
  return /\.(mp4|webm|ogg)(\?.*)?$/i.test(url || "");
}

export default function SearchBar() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [clickedResult, setClickedResult] = useState(false);

  const timeoutRef = useRef(null);
  const wrapperRef = useRef(null);
  const navigate = useNavigate();

  const handleSearch = (e) => {
    const value = e.target.value;
    setQuery(value);
    clearTimeout(timeoutRef.current);

    if (!value.trim()) {
      setResults([]);
      setShowDropdown(false);
      return;
    }

    timeoutRef.current = setTimeout(() => {
      fetch(`https://ecomapi.asherjewels.com.ph/apiecom/search-web.api.php?query=${encodeURIComponent(value)}`)
        .then((res) => res.json())
        .then((products) => {
          setResults(products || []);
          setShowDropdown(true);
        })
        .catch((err) => {
          console.error("Search error:", err);
          setResults([]);
          setShowDropdown(true);
        });
    }, 300);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (clickedResult) {
        setClickedResult(false);
        return;
      }
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [clickedResult]);

  const handleOpenProduct = (item) => {
    setClickedResult(true);
    setShowDropdown(false);
    navigate(`/product/${item.id}`);
  };

  return (
    <div className="search-container" ref={wrapperRef}>
      <input
        type="text"
        className="search-input"
        placeholder="Search for jewelry..."
        value={query}
        onChange={handleSearch}
      />
      {showDropdown && (
        <div className="search-results">
          {results.length === 0 ? (
            <div className="search-item-title">No results found.</div>
          ) : (
            results.map((product) => (
              <div
                key={product.id}
                className="search-item"
                onClick={() => handleOpenProduct(product)}
                style={{ cursor: "pointer" }}
              >
                {isVideoUrl(product.imageUrl) ? (
                  <video src={`${oneSystem}${product.imageUrl}`} muted playsInline preload="metadata" />
                ) : (
                  <img src={`${oneSystem}${product.imageUrl}`} alt={product.name} />
                )}
                <div style={{ flex: 1 }}>
                  <div className="search-item-title">{product.name}</div>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
